<template>
  <!-- 输入验证码 -->
  <div class="forget-password">
    <el-form
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      label-position="top"
    >
      <!-- 验证码输入框 -->
      <el-form-item :label="$t('pages.login.text20')">
        <DiluValidatorInput @complete="complete" :codeState="codeState" />
      </el-form-item>
      <el-form-item>
        <!-- 倒计时 -->
        <el-button v-if="time > 0" class="btn" type="primary"
          >{{ time }}s</el-button
        >
        <!-- 重新发送验证码 -->
        <el-button
          v-else
          class="btn red-btn"
          type="primary"
          @click="submit()"
          >{{ $t("pages.login.text21") }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import DiluValidatorInput from "../../components/pubilc/dilu-validatorInput.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      time: 10, //十秒倒计时
      mailAddress: "", // 邮箱地址
      codeState: true, //按钮状态
    };
  },
  components: {
    DiluValidatorInput,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    // 获取上个页面邮箱地址，并开启倒计时十秒
    this.mailAddress = this.$route.query.mailAddress;
    let timeOut = setInterval(() => {
      if (this.time < 1) {
        clearInterval(timeOut);
      } else {
        this.time--;
      }
    }, 1000);
  },
  methods: {
    //验证码输入完成
    complete(e) {
      this.codeState = true;
      let that = this;
      console.log(this);
      let str = "?code=" + e + "&mailAddress=" + this.mailAddress+ "&platformId=" + this.platformData.id;
      this.request
        .checkVerificationCode(str)
        .then((res) => {
          this.codeState = true;
          this.$router.push({
            path: "/resetPassword",
            query: {
              mailAddress: that.mailAddress,
              trustCode: res.data,
            },
          });
        })
        .catch((err) => {
          console.log(err);
          this.codeState = false;
          this.$message.error(err.msg);
        });
    },
    // 重新发送验证码
    submit() {
      this.codeState = true;
      let str =
        "?mailAddress=" +
        this.mailAddress +
        "&platformId=" +
        this.platformData.id;
      this.request
        .getVerificationCode(str)
        .then(() => {
          this.time = 10;
          let timeOut = setInterval(() => {
            if (this.time < 1) {
              clearInterval(timeOut);
            } else {
              this.time--;
            }
          }, 1000);
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
  },
};
</script>

<style scoped>
.forget-password {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demo-ruleForm {
  width: 340px;
  margin-top: 200px;
}
.btn {
  width: 100%;
  border-radius: 15px;
}
.red-btn {
  background-color: rgba(217, 0, 27, 0.643137254901961);
  border: none;
}
</style>